// src/config.js

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://backend.fasterlink.me/api/v1';

export default BACKEND_URL;
